import { makeStyles } from '@material-ui/core';

// OPS-95 — Edgebeam stacked logo for sidebar (drawer-closed).
// Source SVG: 20251218_EdgeBeam_Brand Guidelines/Stacked Logos/
//             EdgeBeam_Logo_White.FullColor_Square.svg
// Hybrid: white EDGE/BEAM/WIRELESS letters + gradient on the large WIRELESS.
// Designed for dark backgrounds (sidebar Ink #071D49).
// Width-constrained to 36px so it fits the closed drawer (~48px usable
// after the 24px left margin from SidebarLogo.tsx).
const useStyles = makeStyles({
  svg: {
    width: 36,
    height: 'auto',
    display: 'block',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 485.91 238"
      role="img"
      aria-label="Edgebeam"
    >
      <defs>
        <linearGradient
          id="edgebeam-logo-icon-grad"
          x1="178.22"
          y1="182.71"
          x2="485.22"
          y2="182.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#173EA7" />
          <stop offset="0.35" stopColor="#89BFDF" />
          <stop offset="0.7" stopColor="#F6CA54" />
          <stop offset="1" stopColor="#EF8F48" />
        </linearGradient>
      </defs>

      <g fill="#FFFFFF">
        <path d="M69,180.9c10.1-5.41,15.01-13.25,15.01-23.95v-.31c0-7.11-2.46-13.17-7.3-18.02-6.29-6.29-16.09-9.61-28.33-9.61H-.15v108.16h50.08c25.1,0,40.08-11.13,40.08-29.78v-.31c0-12.82-6.68-21.15-21-26.19ZM64.59,160.03c0,9.13-7.31,14.36-20.05,14.36h-25.59v-28.11h26.97c11.86,0,18.66,4.9,18.66,13.44v.31ZM18.95,190.88h29.74c14.33,0,21.9,4.91,21.9,14.21v.31c0,9.22-7.48,14.51-20.51,14.51h-31.12v-29.03Z" />
        <polygon points="185.23 146.44 185.23 129.02 104.91 129.02 104.91 237.18 163.95 237.18 163.95 219.76 124.32 219.76 124.32 191.5 171.7 191.5 171.7 173.93 124.32 173.93 124.32 146.44 185.23 146.44" />
      </g>

      <path
        fill="url(#edgebeam-logo-icon-grad)"
        d="M465.73,210.45l-.07.13c-3.19,5.58-9.58,8.49-15.91,7.25-5.66-1.14-10.05-5.39-11.46-11.11-2.27-8.38-4.34-18.86-5.71-25.8-5.85-29.64-10.47-53.05-27.02-53.05-16.55,0-21.15,23.42-26.99,53.1-2.21,11.25-5.53,28.12-8.95,35.62-3.44-7.5-6.78-24.38-9-35.65-5.86-29.63-10.49-53.04-27.05-53.04-16.56,0-21.16,23.42-26.99,53.07-1.53,7.75-3.62,18.36-5.93,26.7l-.06.23h.02c-.31,1.49-2.62,10.85-10.5,11.16-4.8.19-8.63-3.57-11.8-11.5l-34.63-79.31h-17.86l-47.44,108.58-.15.35h19.93l11.07-25.99h50.58l2.03,4.88.08-.04c5.16,13.03,16.09,21.43,27.91,21.43.15,0,.3,0,.45-.01.18,0,.36-.01.55,0,.21,0,.42,0,.63,0,19.91,0,27.11-25.73,27.18-25.99,2.25-8.1,4.2-17.75,6-26.93l.02-.11c2.21-11.22,5.53-28.06,8.94-35.53,3.44,7.5,6.78,24.38,9,35.64,5.86,29.64,10.48,53.04,27.05,53.04,16.55,0,21.16-23.42,26.98-53.07,2.21-11.23,5.52-28.07,8.94-35.57,3.43,7.51,6.76,24.38,8.98,35.62,1.82,9.22,3.48,17.45,5.38,24.75v.03c.02.06.03.11.05.17.01.04.02.08.03.13.06.21.11.43.16.65.07.28.14.55.21.82l.05.14c3.13,12.67,12.96,22.12,25.7,24.68,2.17.44,4.38.66,6.57.66,15.33,0,28.97-10.84,32.44-25.77l.07-.31-19.48.02ZM252.66,193.92h-36.31l18.08-42.18,18.23,42.18Z"
      />

      <g fill="#FFFFFF">
        <polygon points="19.28 65.2 66.64 65.2 66.64 47.63 -.14 47.63 -.14 110.88 80.95 110.88 80.95 93.46 19.28 93.46 19.28 65.2" />
        <rect x="-.14" y="2.72" width="80.32" height="17.42" />
        <path d="M137.34,2.72h-40.39v108.16h40.39c16.25,0,30.97-5.55,41.47-15.62,10.31-9.9,15.99-23.56,15.99-38.46v-.31c0-31.16-24.17-53.77-57.46-53.77ZM174.46,57.11c0,10.23-3.6,19.41-10.13,25.87-6.74,6.66-16.07,10.17-26.99,10.17h-20.98V20.44h20.98c21.86,0,37.12,14.95,37.12,36.35v.31Z" />
        <path d="M261.56,67.35h27.53v19.62c-6.91,5.1-16.29,8.03-25.74,8.03-21.4,0-36.35-15.71-36.35-38.2v-.31c0-10,3.53-19.41,9.95-26.48,6.5-7.16,15.28-11.11,24.71-11.11,13.62,0,21.83,4.53,29.98,11.32l.19.16,12.32-14.69-.19-.16c-12.3-10.42-24.33-14.67-41.53-14.67-15.5,0-29.74,5.9-40.11,16.61-10.1,10.44-15.66,24.4-15.66,39.32v.31c0,15.47,5.45,29.55,15.36,39.62,10.28,10.46,24.36,15.99,40.72,15.99,20.99,0,36.09-9.15,45.07-16.82l.09-.07v-45.58h-46.33v17.11Z" />
        <polygon points="345.37 93.46 345.37 65.2 392.74 65.2 392.74 47.63 345.37 47.63 345.37 20.14 406.28 20.14 406.28 2.72 325.96 2.72 325.96 110.88 407.04 110.88 407.04 93.46 345.37 93.46" />
      </g>
    </svg>
  );
};
